// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1ZHtW","box":"WorkspacesBox_box__2gzML","node":"WorkspacesBox_node__2VEAp"};